import { useAuth } from '@/providers/AuthProvider';
import { Button } from '@/components/ui/button';

export function NotAuthorisedPage() {
  const { signOut } = useAuth();
  return (
    <div className="mx-auto flex min-h-screen max-w-sm flex-col justify-center gap-4 p-21 text-center">
      <h1 className="text-xl font-semibold">Not authorised</h1>
      <p className="text-sm text-text-secondary">
        The console is for medical advisors and admins. Your account doesn’t have access.
      </p>
      <Button variant="outline" onClick={signOut}>Sign out</Button>
    </div>
  );
}
